function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M437.44,469.11A264.26,264.26,0,0,1,241,530.28C95.27,516.14-11.38,386.55,2.76,240.85c13-134.12,123.83-235.14,255-239.35"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M437.44,469.11c-11.73.43-24.62.91-36.63-.25-145.7-14.14-252.36-143.73-238.22-289.44,7-72.19,43.57-134.84,95.17-177.92"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "416.91 47.22 381.18 75.98 339.78 64.72 356.97 104.61 330.3 143.13 376.5 139.18"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "416.91 47.22 419.89 93 456.19 115.88 415.18 130.19 404.83 175.88 376.5 139.18"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "377.57 310.15 359.77 285.49 368.67 258.46 341.65 268.46 317.07 249.45 318.08 280.19"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "377.57 310.15 347.15 310.53 330.74 333.77 322.69 306.11 292.78 297.67 318.08 280.19"
})));

const SvgNight = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 457.69 533.04",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/night.75522627.svg";
export { ForwardRef as ReactComponent };